<template>
        <md-snackbar :md-position="position" :md-duration="duration" :md-active="snackBarShow" md-persistent 
          @md-opened="closeSnackBar" class="snackbar">
        <span class="title">{{ $t(snackBarTitle) }}</span>
        <md-button class="button" @click="closeSnackBar">Anuluj</md-button>
        </md-snackbar>
</template>

<script>
import store from '../store'
import { mapGetters } from 'vuex';

export default {
  name: 'SnackBar',
  computed: {
      ...mapGetters("snackbar", ["snackBarTitle"]),
      ...mapGetters("snackbar", ["snackBarShow"]),
  },
  data: () => ({
    position: "left",
    duration: 4000
  }),
  methods: {
    closeSnackBar() {
        store.commit('snackbar/SNACKBAR_TITLE', "")
        store.commit('snackbar/SNACKBAR_SHOW', false)
    },
  },
}
</script>

<style lang="scss" scoped>
.snackbar{
  padding: 20px;
  border-radius: 5px;
  .title {
    font-size: 23px;
  }
  .button {
    color: rgb(1, 161, 161);
    font-weight: 600;
    width: 50%;
  }
}
</style>